import { BookmarkFill } from 'react-bootstrap-icons';
import { useNavigate } from 'react-router-dom';

import { Typography } from 'antd';

import BaseCard from '@/components/shared/BaseCard';
import Shelf from '@/components/shared/Shelf';
import { getCdnUrl } from '@/helpers';
import { useGetRecentlySavedShelfQuery } from '@/services/resume';
import styled, { StyledProp } from '@/styled';

const RecentlySavedShelf = (props: StyledProp) => {
  const navigate = useNavigate();
  const { data, isFetching } = useGetRecentlySavedShelfQuery('');

  if (!data?.length && !isFetching) {
    return null;
  }

  return (
    <div className={props.className}>
      <Shelf
        shelfProps={{
          isFetching
        }}
        title={
          <>
            <Typography.Title level={4} ellipsis id='recently-saved-shelf'>
              Salvo recentemente
            </Typography.Title>
            <Typography.Link underline href='/aulas/salvas' id='savedLessons-seeAll-clickable-text'>
              Ver todos
            </Typography.Link>
          </>
        }
        carouselProps={{ slidesToShow: 5 }}
      >
        <>
          {data?.map(lesson => (
            <swiper-slide key={lesson.id}>
              <BaseCard
                onClick={() => navigate(`/curso/${lesson.course_hash}/aula/${lesson.id}`)}
                image={{
                  src: getCdnUrl(lesson.new_image, lesson.image, lesson.course_image),
                  aspect: '16:9',
                  alt: lesson.title
                }}
                extraContent={
                  <div className='saved-lesson-card-mark' id={`saved-lesson-card-mark-${lesson.id}`}>
                    <BookmarkFill size={32} />
                  </div>
                }
                internalSpace={16}
                id={`recently-saved-card-${lesson.id}`}
              >
                <Typography.Paragraph ellipsis>{lesson.title}</Typography.Paragraph>
              </BaseCard>
            </swiper-slide>
          ))}
        </>
      </Shelf>
    </div>
  );
};

export default styled(RecentlySavedShelf)`
  & swiper-slide > div {
    padding-top: 8px;
  }

  & .carouselNavigator-container {
    height: calc(100% - 24px - 1rem - 8px);
  }

  .base-card-data {
    .ant-typography {
      margin-bottom: 0;
      color: ${({ theme }) => theme.colorTextSecondary};
    }
  }

  .saved-lesson-card-mark {
    position: absolute;
    top: 0;
    left: 12px;
    z-index: 6;
    color: ${({ theme }) => theme.colorIcon};

    svg {
      filter: drop-shadow(0px 1px 9px rgb(0 0 0 / 0.4));
    }
  }
`;
